import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const coreLogic = defineConnector({
  identifier: "coreLogic",
  name: "CoreLogic",
  tagLine: "Property data and analytics",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () =>
    "https://(api-prod\\.corelogic\\.com|prod\\.corelogicapi\\.com|api[^/]*\\.corelogic\\.com)/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [CoreLogic developer portal](https://developer.corelogic.com/#/user-stats) and copy your **Client Key** and **Secret** from the **API Keys** section.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "Client key",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api-prod.corelogic.com/oauth/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.corelogic.com/property/v2/health",
  },
});
